import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./EquipmentsListModal.css";
import { CreateEquipments, CreateScenarioCommand } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import { useNavigate } from "react-router-dom";

const ScenarioCommandInfoModal = ({ equipment }) => {
  const { setScenarioCommandInfoModal, addScenarioCommandDetail } =
    useContext(Context);
  const [commandName, setCommandName] = useState();
  const [time, setTime] = useState();
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setScenarioCommandInfoModal(modalName);
  }, []);

  const handleAddCommand = () => {
    // CreateScenarioCommand({
    //   room_id,
    //   type,
    //   name,
    // })
    //   .then(({ data }) => {
    //     SuccessToast("تجهیز با موفقیت افزوده شد");
    //     setEquipmentName("");
    //     closeEquipmentListButton.current.click();
    //     closeButton.current.click();
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="equipmentsName"
      tabIndex="-1"
      aria-labelledby="equipmentsNameLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              انتخاب نام و مدت تاخیر دستور
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="commandName" className="form-label">
                نام دستور را وارد کنید
              </label>
              <input
                type="text"
                className="form-control"
                id="commandName"
                value={commandName}
                onChange={(e) => setCommandName(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="time" className="form-label">
                مدت تاخیر را به ثانیه وارد کنید
              </label>
              <input
                type="text"
                className="form-control"
                id="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
              />
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleAddCommand}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScenarioCommandInfoModal;
